import { PagedQueryRequest } from "../Pocos/Pagination/PagedQueryRequest";

export default class QueryEducatorsRequest extends PagedQueryRequest {
  SiteId: string | null = null;
  IsActive: boolean | null = null;
}
